import { random as _random } from 'lodash';

export function randomSeed() {
    const random_seed = _random(1, true);
    return Math.ceil(random_seed.toFixed(5) * 1000);
}
